// extracted by mini-css-extract-plugin
export default {"container":"modalOrder_container__ML-Px","header":"modalOrder_header__QtAwf","pic":"modalOrder_pic__mg7xU"};